import { cloneDeep } from "lodash";

export const EndOfMonth = (date: Date) => {
  const lastDayOfMonth = cloneDeep(date);
  lastDayOfMonth.setDate(1); // set the date to the first day of the current month
  lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1); // set the month to the next month
  lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1); // set the date to the last day of the
  return lastDayOfMonth;
};
